// extracted by mini-css-extract-plugin
module.exports = {"chats_container":"_103a151b99--chats_container--prm5J","list":"_103a151b99--list--IK9Sk","chat":"_103a151b99--chat--xeATY"};